import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/cs.ts
var add = "Přidat";
var remove = "Odebrat";
var removeAll = "Odebrat vše";
var incomplete = "Pardon, ale ne všechna pole jsou vyplněna správně.";
var submit = "Odeslat";
var noFiles = "Žádný soubor nebyl vybrán";
var moveUp = "Pohyb nahoru";
var moveDown = "Posunout dolů";
var isLoading = "Načítání...";
var loadMore = "Načíst více";
var next = "Další";
var prev = "Předchozí";
var addAllValues = "Přidat všechny hodnoty";
var addSelectedValues = "Přidání vybraných hodnot";
var removeAllValues = "Odstraňte všechny hodnoty";
var removeSelectedValues = "Odstranění vybraných hodnot";
var chooseDate = "Zvolte datum";
var changeDate = "Změnit datum";
var close = "Zavřít";
var open = "Otevřeno";
var accepted = function({
  name
}) {
  return `Prosím, zaškrtněte ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} musí být po ${date(args[0])}.`;
  }
  return `${sentence(name)} musí být v budoucnosti.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} může obsahovat pouze písmena.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} může obsahovat pouze písmena a čísla.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} musí obsahovat abecední znaky.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} musí obsahovat písmena nebo číslice.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} musí obsahovat písmena nebo mezery.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} musí obsahovat symbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} musí obsahovat velká písmena.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} musí obsahovat malá písmena.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} musí obsahovat čísla.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} musí být symbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} může obsahovat pouze velká písmena.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} může obsahovat pouze malá písmena.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} musí být před ${date(args[0])}.`;
  }
  return `${sentence(name)} musí být v minulosti.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Toto pole bylo špatně nakonfigurováno a nemůže být odesláno.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} musí být mezi ${a} a ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} nejsou shodná.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} není platné datum, prosím, použijte formát ${args[0]}`;
  }
  return "Toto pole bylo špatně nakonfigurováno a nemůže být odesláno.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} musí být mezi ${date(args[0])} a ${date(args[1])}`;
};
var email = "Prosím, zadejte platnou e-mailovou adresu.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} nekončí na ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} není povolená hodnota.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} musí mít nejméně jeden znak.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} může mít maximálně ${max2} znaků.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} by mělo být ${max2} znaků dlouhé.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} musí obsahovat minimálně ${min2} znaků.`;
  }
  return `${sentence(name)} musí být dlouhé ${min2} až ${max2} znaků.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} není povolená hodnota.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Nelze použít více než ${args[0]} ${name}.`;
  }
  return `${sentence(name)} musí mít menší nebo rovno než ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Nejsou nakonfigurovány povolené typy souborů.";
  }
  return `${sentence(name)} musí být typu: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Nelze mít méně než ${args[0]} ${name}.`;
  }
  return `${sentence(name)} musí být minimálně ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” není dovolená hodnota pro ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} musí být číslo.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" nebo ")} je vyžadován.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} je povinné.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} nezačíná na ${list(args)}.`;
};
var url = function() {
  return `Zadejte prosím platnou adresu URL.`;
};
var invalidDate = "Vybrané datum je neplatné.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var cs_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, cs_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=cs.mjs.map